"use client";
import React from "react";
import styles from "../css/collectionTable.module.css";

export default function CollectionTable({ columns, data }) {
  return (
    <div className={styles.tableCard}>
      <div className={styles.headerStrip}>
        {columns.map((col) => (
          <div key={col.header} className={styles.th}>
            {col.header}
          </div>
        ))}
      </div>
      <div className={styles.body}>
        {data.map((row, idx) => (
          <div key={idx} className={styles.tr}>
            {columns.map((col) => (
              <div key={col.header} className={styles.td}>
                {col.render ? col.render(row[col.accessor], row) : row[col.accessor]}
              </div>
            ))}
          </div>
        ))}
        {data.length === 0 && (
          <div className={styles.empty}>No results</div>
        )}
      </div>
    </div>
  );
}
